module.exports = __webpack_public_path__ + "static/media/favIcon3.e5f739a4.jpg";